import css from 'styled-jsx/css';
import { display } from 'styles/css-constants';
import { MQ_LARGE } from 'constants/mq';

export default css`
  .ProductTeaserList__heading :global(h2) {
    margin-bottom: 1rem;
    font-family: ${display};
    font-size: var(--fontScale3);
  }

  @media screen and ${MQ_LARGE} {
    margin-bottom: 1.5rem;
  }
`;
